
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldImage from "./FieldImage";
import FieldText from "./FieldText";
import FieldTitle from "./FieldTitle";

export default function Form({ publication }) {
	const navigate = useNavigate();
	const params = useParams();
	const publicationId = params.publicationId;
	const [title, setTitle] = useState(publication.title);
	const [text, setText] = useState(publication.text);
	const [image, setImage] = useState(publication.image);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleTextChange = (value) => {
		setText(value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.publicationEdit({
			token: LoginHelper.getToken(),
			publication_id: publicationId,
			title: title,
			text: text,
			image_file: image,
		}).then((res) => {
			setIsLoading(false);
			navigate('/publication_detail/' + publicationId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="ویرایش مقاله"
			subtitle="تغییرات مقاله را ذخیره کنید."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="ذخیره مقاله"
		>
			<EditorFieldSection title="عنوان و متن">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldText text={publication.text} onChange={handleTextChange} />
			</EditorFieldSection>
			<EditorFieldSection title="تصویر شاخص">
				<FieldImage image={image} onChange={handleImageChange} />
			</EditorFieldSection>
		</EditorFormShell>
	);
}
